import { request } from '@/utils/request';
import * as url from '@/src/constant';

const ROUTE_SALARY = '/pages/task-hall/index';

/**
 * 获取灵工任务列表
 * @param query
 * @returns {Promise<TResult>}
 */
export function queryFreelancerTaskList(query) {
  return request({
    url: url.QUERY_FREELANCER_TASK_LIST,
    query,
    method: "POST",
    returnUrl: ROUTE_SALARY
  });
}

/**
 * 查询灵工任务详情
 * @param query
 * @returns {Promise<TResult>}
 */
export function queryFreelancerTaskDetail(query) {
  return request({
    url: url.QUERY_FREELANCER_TASK_DETAIL,
    query,
    method: "POST",
    returnUrl: ROUTE_SALARY
  });
}

// 查询企业任务详情
export function queryTaskDetail(query) {
  return request({
    url: url.QUERY_TASK_DETAIL,
    query,
    method: "POST",
    returnUrl: ROUTE_SALARY
  });
}

// 接受任务
export function acceptTask(query) {
  return request({
    url: url.ACCEPT_TASK,
    query,
    method: "POST",
    returnUrl: ROUTE_SALARY
  });
}

// 拒绝任务
export function rejectTask(query) {
  return request({
    url: url.REJECT_TASK,
    query,
    method: "POST",
    returnUrl: ROUTE_SALARY
  });
}

// 确认完成任务
export function completeTask(query) {
  return request({
    url: url.COMPLETE_TASK,
    query,
    method: "POST",
    returnUrl: ROUTE_SALARY
  });
}

// 查询交付物
export function queryDelivery(query) {
  return request({
    url: url.QUERY_DELIVERY,
    query,
    method: "POST",
    returnUrl: ROUTE_SALARY
  });
}

// 编辑交付物
export function editDelivery(query) {
  return request({
    url: url.EDIT_DELIVERY,
    query,
    method: "POST",
    returnUrl: ROUTE_SALARY
  });
}
